var _GlobalStyle, _Cow;
import { useEffect } from 'react';
import { useAmplitude } from '@crehana/analytics';
import CrehanaLogo from '@crehana/icons/logos/CrehanaLogo';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors, TextLink } from '@crehana/ui';
import data from "./404.data";
import { Background, Cow, GlobalStyle, Header, Links, MainTitle, MainTitleMobile } from "./404.styles";

/* Not Found */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NotFound = function NotFound() {
  var _useAmplitude = useAmplitude(),
    logEvent = _useAmplitude.logEvent;
  var handleGotoBack = function handleGotoBack(url) {
    if (url === 'home') {
      logEvent({
        event: 'Click Regresar 404',
        data: {},
        callback: function callback() {
          window.location.href = data.backButton.link;
        }
      });
    } else {
      logEvent({
        event: 'Click Catalog 404',
        data: {},
        callback: function callback() {
          window.location.href = data.coursesButton.link;
        }
      });
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    logEvent({
      event: 'Render 404 Landing',
      data: {
        Url: window.location.href
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs(Background, {
    className: "text-white",
    children: [_GlobalStyle || (_GlobalStyle = /*#__PURE__*/_jsx(GlobalStyle, {})), /*#__PURE__*/_jsx(Header, {
      children: /*#__PURE__*/_jsx("span", {
        className: "mt-4",
        children: /*#__PURE__*/_jsx(CrehanaLogo, {
          size: 23,
          color: colors.white
        })
      })
    }), /*#__PURE__*/_jsxs(MainTitle, {
      children: [/*#__PURE__*/_jsx("h1", {
        className: "font-main-title",
        children: data.title
      }), /*#__PURE__*/_jsx("p", {
        className: "font-h4-reg",
        children: data.subTitle1
      }), /*#__PURE__*/_jsx("p", {
        className: "font-h4-reg",
        children: data.subTitle2
      })]
    }), /*#__PURE__*/_jsxs(MainTitleMobile, {
      children: [/*#__PURE__*/_jsx("h1", {
        className: "font-main-title",
        children: data.title
      }), /*#__PURE__*/_jsx("p", {
        className: "font-body2",
        children: data.subTitle1
      }), /*#__PURE__*/_jsx("p", {
        className: "font-body2",
        children: data.subTitle2
      })]
    }), /*#__PURE__*/_jsxs(Links, {
      children: [/*#__PURE__*/_jsx(TextLink, {
        type: "button",
        className: "block mb-16 text-white underline",
        onClick: function onClick() {
          return handleGotoBack('home');
        },
        children: data.backButton.text
      }), /*#__PURE__*/_jsx(TextLink, {
        type: "button",
        className: "block text-white underline",
        label: data.coursesButton.text,
        onClick: function onClick() {
          return handleGotoBack('course');
        }
      })]
    }), _Cow || (_Cow = /*#__PURE__*/_jsx(Cow, {}))]
  });
};
export var getStaticProps = function getStaticProps() {
  return {
    props: {
      isErrorPage: true
    }
  };
};
export default NotFound;